import { Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from 'src/app/service/auth.service';

@Component({
	selector: 'app-change-password',
	templateUrl: './change-password.component.html',
	styleUrls: ["./change-password.component.scss"]
})
export class ChangePasswordComponent {

	hideOldPassword = true;
	hideNewPassword = true;
	hideConfirmPassword = true;
	submitted = false;
	errorMessage: string = '';

	form: FormGroup = this.fb.group({
		currentPassword: ['', [Validators.required, Validators.minLength(8)]],
		newPassword: ['', [Validators.required, Validators.minLength(8)]],
		confirmPassword: ['', []]
	}, { validators: this.matchPasswords });

	constructor(
		private fb: FormBuilder,
		private dialogRef: MatDialogRef<ChangePasswordComponent>,
		private authService: AuthService,
		private snackBar: MatSnackBar
	) { }

	matchPasswords(group: AbstractControl): ValidationErrors | null {
		const pass = group.get('newPassword')?.value;
		const confirm = group.get('confirmPassword')?.value;
		return pass === confirm ? null : { mismatch: true };
	}

	onCancel(): void {
		this.dialogRef.close();
	}

	onSubmit(): void {
		this.errorMessage = '';
		this.submitted = true;
		if (this.form.invalid)
			return;

		this.authService.changePassword(this.form.value)
			.subscribe(
				data => {
					this.snackBar.open("Password has been changed, Please Re-login.", '', { duration: 3000 });
					this.dialogRef.close();
					this.authService.logout();
				},
				error => {
					this.errorMessage = error.message;
				}
			);
	}
}
